import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PATRON_CEDULA = /^[0-9]{7,8}$/;

export const TIPOS_CEDULA = [
  { valor: 'Licenciatura', nombre: 'Licenciatura' },
  { valor: 'Especialidad', nombre: 'Especialidad' },
  { valor: 'Maestría', nombre: 'Maestría' },
];

// Evita enviar el mismo número de cédula dos veces
export function cedulasSinDuplicados(control: AbstractControl): ValidationErrors | null {
  const numeros = (control.value ?? [])
    .map((c: any) => String(c?.cedula ?? '').trim())
    .filter((n: string) => n !== '');

  return new Set(numeros).size !== numeros.length ? { cedulaDuplicada: true } : null;
}
